export const STANDARD = 'STANDARD SHIPPING';
export const EXPEDITED = 'EXPEDITED';
export const TWO_DAY = '2 DAY SHIPPING';
export const TWO_DAY_TOOLTIP_COPY = '($40 per device)';
